import { useMe } from '@/api/queries';

export function useAuth() {
  const { data, isLoading, isError } = useMe();
  return {
    user: data?.user ?? null,
    isLoading,
    isAuthenticated: !!data?.user,
    isError,
  };
}
